// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RelatedEntities_related-entities__RnpcB li {
  padding: 12px 12px 12px 0;
}

.RelatedEntities_related-faculty-card__Lfy4T {
  box-shadow: none !important;
  border: 1px solid var(--light-grey);
}

.RelatedEntities_related-institution-card__l7iO7 {
  box-shadow: none !important;
  border: 1px solid var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/RelatedEntities/RelatedEntities.module.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;AAAJ;;AAGA;EACE,2BAAA;EACA,mCAAA;AAAF;;AAGA;EACE,2BAAA;EACA,mCAAA;AAAF","sourcesContent":[".related-entities {\n  li {\n    padding: 12px 12px 12px 0;\n  }\n}\n.related-faculty-card {\n  box-shadow: none !important;\n  border: 1px solid var(--light-grey);\n}\n\n.related-institution-card {\n  box-shadow: none !important;\n  border: 1px solid var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"related-entities": `RelatedEntities_related-entities__RnpcB`,
	"related-faculty-card": `RelatedEntities_related-faculty-card__Lfy4T`,
	"related-institution-card": `RelatedEntities_related-institution-card__l7iO7`
};
export default ___CSS_LOADER_EXPORT___;
